import { apiRequest } from '../utils/api';

export const submitConversationReport = (payload) =>
  apiRequest(
    '/api/v1/conversation-reports',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
    { maxRetries: 0 },
  );

export const getAdminConversationReports = ({
  status,
  page = 1,
  limit = 100,
} = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });
  if (status) params.set('status', status);
  return apiRequest(`/api/v1/conversation-reports/admin?${params.toString()}`);
};

export const updateConversationReport = (reportId, payload) =>
  apiRequest(
    `/api/v1/conversation-reports/admin/${reportId}`,
    {
      method: 'PATCH',
      body: JSON.stringify(payload),
    },
    { maxRetries: 0 },
  );
